import { useCallback } from 'react';

import { sortEntities } from 'utils/clickme';
import { ADMIN_OVERFLOW_CAMPAIGN_ID, ADMIN_OVERFLOW_SOURCE, ADMIN_OVERFLOW_VALUE } from 'utils/constants/admin';

import useTrls from 'hooks/translation/useTrls';

import LabelSort from 'components/LabelSort';

import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { setOverflows, setSorts } from 'store/models/overflow';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Reports/OverflowReport/Header/Header.less';

const Header = () => {
    const { sorts, overflows } = useSelector((state) => state.overflow);
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClickHeadCell = useCallback(
        (field) => {
            const { newItems, newSorts } = sortEntities(overflows, sorts, field);
            dispatch([setSorts(newSorts), setOverflows(newItems)]);
        },
        [dispatch, overflows, sorts]
    );
    return (
        <TableHead>
            <TableRow>
                <TableHeadCell className="overflow-column">
                    <LabelSort
                        columnKey={ADMIN_OVERFLOW_CAMPAIGN_ID}
                        sorts={sorts}
                        onClick={() => onClickHeadCell(ADMIN_OVERFLOW_CAMPAIGN_ID)}
                    >
                        {trl(`admin.OverflowReport.Header.${ADMIN_OVERFLOW_CAMPAIGN_ID}`)}
                    </LabelSort>
                </TableHeadCell>
                <TableHeadCell className="overflow-column">
                    <LabelSort
                        columnKey={ADMIN_OVERFLOW_VALUE}
                        sorts={sorts}
                        onClick={() => onClickHeadCell(ADMIN_OVERFLOW_VALUE)}
                    >
                        {trl(`admin.OverflowReport.Header.${ADMIN_OVERFLOW_VALUE}`)}
                    </LabelSort>
                </TableHeadCell>
                <TableHeadCell className="overflow-column">
                    <LabelSort
                        columnKey={ADMIN_OVERFLOW_SOURCE}
                        sorts={sorts}
                        onClick={() => onClickHeadCell(ADMIN_OVERFLOW_SOURCE)}
                    >
                        {trl(`admin.OverflowReport.Header.${ADMIN_OVERFLOW_SOURCE}`)}
                    </LabelSort>
                </TableHeadCell>
            </TableRow>
        </TableHead>
    );
};

export default Header;
